import {changesHistoryActionTypes} from "../constants/ActionTypes";

const initialState = {
  changesHistory: null,
  needRefresh: false,
  filtersData: null,
  isRequestPending: false,
  options: {},
  subactions: {}
};

const changesHistory = (state = initialState, action) => {
  switch (action.type) {
    case changesHistoryActionTypes.GET_CHANGES_HISTORY:
      return {
        ...state,
        changesHistory: action.changesHistory,
        isRequestPending: false
      };
    case changesHistoryActionTypes.SET_NEED_REFRESH:
      return {
        ...state,
        needRefresh: action.needRefresh
      };
    case changesHistoryActionTypes.GET_OPTIONS:
      return {
        ...state,
        options: action.options,
        subactions: action.subactions
      };
    case changesHistoryActionTypes.IS_REQUEST_PENDING:
      return {
        ...state,
        isRequestPending: action.state
      };
  }

  return state;
};

export default changesHistory;



// WEBPACK FOOTER //
// ./reducers/changesHistory.reducers.js